var _a, _b, _c, _d, _e, _f;
import { createDinTestStore, defaultInitialDinTestState, } from 'hx-din-test';
import { createSimpleStore } from 'hx-simple-store';
import { configureStoreWithRouter, createWidgetStore, } from 'hx-widget-store';
import { createWizardStore } from 'hx-wizard';
export var WIDGET_FEATURE_KEY = (_a = createWidgetStore(), _a.WIDGET_FEATURE_KEY), widgetStoreReducer = _a.widgetStoreReducer, widgetActions = _a.widgetActions, messageListenerMiddleware = _a.messageListenerMiddleware;
export var WIZARD_FEATURE_KEY = (_b = createWizardStore(), _b.WIZARD_FEATURE_KEY), wizardStoreReducer = _b.wizardStoreReducer, wizardActions = _b.wizardActions;
export var DIN_TEST_FEATURE_KEY = (_c = createDinTestStore(defaultInitialDinTestState, {
    cutOffs: [
        { snr: -15.7, category: 'normal' },
        { snr: -11.7, category: 'mild' },
        { snr: 100, category: 'moderate' },
        { snr: Infinity, category: 'severe' },
    ],
}), _c.DIN_TEST_FEATURE_KEY), dinTestStoreReducer = _c.dinTestStoreReducer, dinTestActions = _c.dinTestActions, selectActiveTestStep = _c.selectActiveTestStep;
export var earlySubmitWarningReducer = (_d = createSimpleStore('earlySubmitWarning', {
    initialState: {
        'early-submit-count': 0,
        'warning-given': false,
    },
}), _d.earlySubmitWarningReducer), updateEarlySubmitWarning = _d.updateEarlySubmitWarning;
export var store = (_f = configureStoreWithRouter({
    reducers: (_e = {},
        _e[WIDGET_FEATURE_KEY] = widgetStoreReducer,
        _e[WIZARD_FEATURE_KEY] = wizardStoreReducer,
        _e[DIN_TEST_FEATURE_KEY] = dinTestStoreReducer,
        _e.earlySubmitWarning = earlySubmitWarningReducer,
        _e),
    middleware: [messageListenerMiddleware],
}), _f.store), history = _f.history;
